export const getAggregateCardProps = (state, event, dict) => {
    return {
        event,
        handlers: {
            eventCard: state.openGameTranspiler.bind(state, event)
        },
        dict
    };
};
//# sourceMappingURL=getAggregateCardProps.js.map